import { createSlice } from "@reduxjs/toolkit";
import { toasts } from "../../components/common/Toast/Toast";
import { marketPlace } from "../../Services/marketPlaceService";
import { startLoading, stopLoading } from "../loading/loadingSlice";

const initialState = {
  productList: [],
  cartItems: [],
  cartUpdateFlag: false,
};
export const marketPlaceSlice = createSlice({
  name: "marketPlace",
  initialState,
  reducers: {
    setCartUpdateFlag: (state, action) => {
      state.cartUpdateFlag = action.payload;
    },
    setProductList: (state, action) => {
      state.productList = action.payload;
    },
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
    },
  },
});

export const {
  setProductList,
  setCartItems,
  setCartUpdateFlag,
} = marketPlaceSlice.actions;

export default marketPlaceSlice.reducer;

export const fetchProductList = (data) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await marketPlace.getProductList(data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        // reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const addToCartAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await marketPlace.addToCart(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const editToCartAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await marketPlace.updateCart(data);
        // toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getCartListAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await marketPlace.getCartItems(data);
        // newcode added to set cart items in state
        dispatch(setCartItems(response.data.data.items || [])); 
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const deleteCartItemAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await marketPlace.deleteItemFromCart(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const emptyCartAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await marketPlace.emptyCart(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const marketPlaceCheckoutAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await marketPlace.marketPlaceCheckout(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const createIntentAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await marketPlace.getClientSecret(data);
        // toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const stripeWebhookAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await marketPlace.stripeWebhook(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};
